import { NavLink, Outlet } from 'react-router-dom';
import { Text } from '@/components/ui/Text';
import { IconHome, IconList, IconMore, IconPlus, type IconProps } from '@/components/icons';
import styles from './TabsLayout.module.css';

const TABS: Array<{ to: string; label: string; Icon: (p: IconProps) => React.ReactElement }> = [
  { to: '/', label: 'ໜ້າຫຼັກ', Icon: IconHome },
  { to: '/sell', label: 'ຂາຍ', Icon: IconPlus },
  { to: '/debt', label: 'ໜີ້', Icon: IconList },
  { to: '/more', label: 'ອື່ນໆ', Icon: IconMore },
];

/**
 * The handoff's bar: 58px, white, hairline on top, and a 2px sky rule above the
 * active item.
 */
export function TabsLayout() {
  return (
    <div className={styles.shell}>
      <div className={styles.content}>
        <Outlet />
      </div>

      <nav className={styles.bar}>
        {TABS.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}
          >
            {({ isActive }) => (
              <>
                <Icon size={19} className={isActive ? styles.iconOn : styles.iconOff} />
                {/* The handoff specifies 10px, but Lao stacks tone marks above the
                    glyph and vowel signs below, so it needs more size than Latin
                    to stay legible at a glance. Deliberately off-spec at 12px —
                    do not "fix" this back. */}
                <Text
                  weight={isActive ? 700 : 500}
                  size={12}
                  color={isActive ? 'var(--k2-sky-deep)' : 'var(--k2-text-muted)'}
                  className={styles.label}
                >
                  {label}
                </Text>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
